import * as api from '@/api/map'
import * as mapApi from '@/pages-v2/Gas/MapGas/service'
import { get } from 'lodash-es'
const DEFAULT_AREA_STATUS = 1 // 筛选商机为商圈维度
const DEFAULT_CITY_STATUS = 2 // 筛选商机为城市维度
/**
 * 获取地区列表
 * @param state
 * @param commit
 * @param params
 * @returns {Promise<*>}
 */
export async function getAreaList ({state, commit, rootGetters}, params) {
  const { areaGroup, geo } = rootGetters
  let data = {}
  try {
    data = await api.fetchAreaList({
      ...params,
      // bdArea|1152921559427252227
      areaId: areaGroup.areaId,
      ...geo
    })
  } catch (error) {
    return false
  }
  commit('updateAreaList', data)
  return data
}

/**
 * 获取商铺列表
 * @param state
 * @param commit
 * @param params
 * @returns {Promise<*>}
 */
export async function getShopList ({state, commit, rootGetters}, params) {
  const { areaGroup, geo } = rootGetters
  let data = {}
  try {
    data = await api.fetchShopList({
      ...params,
      areaId: areaGroup.areaId,
      cityId: areaGroup.cityId || '',
      // 如果areaId里面包含all说明是城市维度，否则是商圈维度
      range: get(areaGroup, 'areaId', '').includes('all') ? DEFAULT_CITY_STATUS : DEFAULT_AREA_STATUS,
      ...geo
    })
  } catch (error) {
    return false
  }
  commit('updateShopList', data)
  return data
}

/**
 * 获取商铺列表
 * @param state
 * @param commit
 * @param params
 * @returns {Promise<*>}
 */
export async function getMapShopList ({state, commit, rootGetters}, params) {
  const { geo } = rootGetters
  const {callback, complete, ...Lparams} = params
  let data = {}
  try {
    data = await mapApi.getMapShopList({
      myLng: geo.lng,
      myLat: geo.lat,
      ...geo,
      ...Lparams
    }).finally(() => {
      complete && complete()
    })
    callback && callback(data)
  } catch (error) {
    return false
  }
  commit('updateMapShopList', data)
  return data
}
